
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.332 6.667H6.665c-1.833 0-3.316 1.5-3.316 3.333l-.017 20c0 1.833 1.5 3.333 3.333 3.333h26.667c1.833 0 3.333-1.5 3.333-3.333V10c0-1.833-1.5-3.333-3.333-3.333zm0 6.666l-13.333 8.334-13.334-8.334V10L20 18.333 33.332 10v3.333z","fill":"currentColor"}})])
          )
        }
      }
    